import React from "react";

interface FilterBarContainerProps {
  children?: React.ReactNode;
  leftSection?: React.ReactNode;
  rightSection?: React.ReactNode;
  className?: string;
}

const FilterBarContainer: React.FC<FilterBarContainerProps> = ({
  children,
  leftSection,
  rightSection,
  className = "",
}) => {
  if (leftSection || rightSection) {
    return (
      <div className={`mb-4 flex items-center justify-between gap-2 ${className}`}>
        {leftSection && <div className="flex items-center gap-2">{leftSection}</div>}
        {rightSection && <div className="flex items-center gap-3">{rightSection}</div>}
      </div>
    );
  }

  return <div className={`mb-4 flex items-center gap-2 ${className}`}>{children}</div>;
};

export default FilterBarContainer;
